import TimeIcon from '@edna/icons/time.svg';

import {EChannelType} from 'src/constants';
import {
  ActionIcon,
  ApiIcon,
  ButtonPressIcon,
  ChatCenterIcon,
  ConditionIcon,
  IncomingMessageIcon,
  JivoIcon,
  MaxBotCircleIcon,
  MaxCircleIcon,
  PauseIcon,
  RocketIcon,
  StartEventIcon,
  TagCrossedIcon,
  TagIcon,
  WhatsAppCircleIcon,
} from 'src/icons';

import {EFlowStepType, ETriggerType, EUIActionType, EUIConditionType} from '../types';

export const STEP_TYPE_ICON: Record<EFlowStepType, TSvgComponentType> = {
  [EFlowStepType.TRIGGER]: StartEventIcon,
  [EFlowStepType.CONDITION]: ConditionIcon,
  [EFlowStepType.ACTION]: ActionIcon,
};

export const CONDITION_TYPE_ICON: Record<
  Exclude<EUIConditionType, EUIConditionType.EMPTY>,
  TSvgComponentType
> = {
  [EUIConditionType.MESSAGE_RECEIVED]: IncomingMessageIcon,
  [EUIConditionType.EXTERNAL_TRIGGER]: RocketIcon,
  [EUIConditionType.BUTTON_PRESSED]: ButtonPressIcon,
  [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: TimeIcon,
  [EUIConditionType.TAG_PRESENCE_CONDITION]: TagIcon,
  [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: () => null,
};

export const ACTION_TYPE_ICON = {
  [EUIActionType.SEND_MESSAGE_ACTION]: WhatsAppCircleIcon,
  [`${[EUIActionType.CREATE_MESSAGE_ACTION]}_${EChannelType.WHATSAPP}`]: WhatsAppCircleIcon,
  [`${[EUIActionType.CREATE_MESSAGE_ACTION]}_${EChannelType.MAX_BOT}`]: MaxBotCircleIcon,
  [`${[EUIActionType.CREATE_MESSAGE_ACTION]}_${EChannelType.MAX}`]: MaxCircleIcon,
  [EUIActionType.CC_DIALOG_SWITCH_ACTION]: ChatCenterIcon,
  [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: JivoIcon,
  [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]: ApiIcon,
  [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: TagIcon,
  [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: TagCrossedIcon,
  [EUIActionType.PAUSE_ACTION]: PauseIcon,
} as Record<EUIActionType | `${EUIActionType}_${EChannelType}`, TSvgComponentType>;

export const TRIGGER_TYPE_ICON: Record<ETriggerType, TSvgComponentType> = {
  [ETriggerType.EVENT]: StartEventIcon,
  [ETriggerType.CONDITION]: ConditionIcon,
  [ETriggerType.ACTION]: ActionIcon,
};

export const getStepPrimaryColor = (theme: TTheme['theme'], type: EFlowStepType) => {
  const COLORS: Record<EFlowStepType, string> = {
    [EFlowStepType.TRIGGER]: theme.palette.green400,
    [EFlowStepType.CONDITION]: theme.palette.blue500,
    [EFlowStepType.ACTION]: theme.palette.orange500,
  };

  return COLORS[type];
};

export const getStepSecondaryColor = (theme: TTheme['theme'], type: EFlowStepType) => {
  const COLORS: Record<EFlowStepType, string> = {
    [EFlowStepType.TRIGGER]: theme.palette.brandAccent50,
    [EFlowStepType.CONDITION]: theme.palette.blue100,
    [EFlowStepType.ACTION]: theme.palette.orange100,
  };

  return COLORS[type];
};

export const getTriggerColor = (theme: TTheme['theme'], type: ETriggerType) => {
  const COLORS: Record<ETriggerType, string> = {
    [ETriggerType.EVENT]: theme.palette.purple500,
    [ETriggerType.CONDITION]: theme.palette.blue500,
    [ETriggerType.ACTION]: theme.palette.orange500,
  };

  return COLORS[type];
};

export const ROOT_HANDLE_ID = 'ROOT_HANDLE';

export enum EEvent {
  EDGES_UPDATED = 'EDGES_UPDATED',
  FLOW_INTERACTION = 'FLOW_INTERACTION',
}
